import { detect } from 'detect-browser';
import publicIp from 'public-ip';
import queryString from 'query-string';
import jwt from 'jsonwebtoken';
import * as submitService from '../services/Submit';

export const saveMobileBlockerVisitInfo = async () => {
    // Check if user is already logged before sending a new request
    const alreadySaved = localStorage.getItem('mobile-blocker-page-logged');
    if (alreadySaved) {
        return
    };
    // Step 1: Create a new URL object
    const urlObject = new URL(window.location.href);
    const params = new URLSearchParams(urlObject.search);
    const source = params.get('source') || null;

    if (!source || source !== 'mobile-blocker-page') {
        return
    }

    const referrerUrl = `${urlObject.host}${urlObject.pathname}?source=${source}`;

    const browser = detect();
    let ip;
    try {
        ip = await publicIp.v4();
      }
      catch (error) { };

      const query = queryString.parse(window.location.search);
      const adsSite = query.s || '';
      const campaignNum = query.n || '';
      const utmSource = query.utm_source || '';
      const utmMedium = query.utm_medium || '';
      const utmCampaign = query.utm_campaign || '';
      const utmContent = query.utm_content || '';
      const utmTerm = query.utm_term || '';
      const token_data = jwt.decode(localStorage.getItem('token'));
      const agentData = {
        ip: ip || '',
        referrerUrl: referrerUrl,
        currentUrl: window.location.href,
        screenWidth: window.screen.width,
        screenHeight: window.screen.height,
        browserName: browser ? (browser.name || '') : '',
        browserVersion: browser ? (browser.version || '') : '',
        os: browser ? (browser.os || '') : '',
        adsSite,
        campaignNum,
        googleStatus: false,
        facebookStatus: false,
        utmSource,
        utmMedium,
        utmCampaign,
        utmContent,
        utmTerm,
        noSubmitInfo: true,
        email: token_data && token_data.email ? token_data.email : ''
      };
      await submitService.addAgentInfo(agentData);
      // Create a log key in localstorage to prevent multiple log within the same session
      localStorage.setItem('mobile-blocker-page-logged', 'true')
}